export default class Render {

    static loadedStyles = new Set();
    static loadedInline = new Set();

    static async request(type, name, params = {}) {

        const nonce = window.WPBS?.settings?.nonce ?? '';

        const res = await fetch(
            `/wp-json/wpbs/v1/${type}/${name}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': nonce,
                },
                body: JSON.stringify(params),
            }
        );

        if (!res.ok) {
            return null;
        }

        const response = await res.json();

        const html = response?.rendered ?? '';

        if (!html) {
            return null;
        }

        this.handleStyles(response?.styles ?? {});

        const rendered = this.toElement(html);

        return {rendered};
    }

    static handleStyles(payload) {

        const {styles = [], inline_css = []} = payload;

        Object.values(styles).forEach((href) => {

            if (!href || this.loadedStyles.has(href)) {
                return;
            }

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.dataset.wpbs = 'dynamic-style';

            document.head.appendChild(link);
            this.loadedStyles.add(href);
        });

        inline_css.forEach((css) => {

            if (!css || this.loadedInline.has(css)) {
                return;
            }

            const style = document.createElement('style');
            style.textContent = css;
            style.dataset.wpbs = 'dynamic-inline';

            document.head.appendChild(style);
            this.loadedInline.add(css);
        });
    }

    static toElement(html) {

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const elements = doc.querySelectorAll('body > *');

        if (!elements.length) {
            return null;
        }

        const wrapper = document.createElement('div');
        wrapper.className = 'wpbs-dynamic-render self-center justify-self-center max-w-full max-h-full';

        elements.forEach(el => wrapper.appendChild(el));

        return wrapper;
    }
}
